<template>
  <div class="modify-wrapper">
    <el-dialog
      :title="$t('modifyPassword')"
      :visible="dialogVisible"
      :close-on-click-modal="!isFirstLogin"
      :close-on-press-escape="!isFirstLogin"
      :show-close="!isFirstLogin"
      append-to-body
      width="600px"
      v-loading="loading"
      @close="handleClose"
      center>
      <p class="top-tip" v-show="isFirstLogin">{{ $t("firstLogin") }}</p>
      <el-form class="style-info-form" :model="formData" ref="formData" label-width="160px" label-suffix="：" :rules="rules">
        <el-form-item :label="$t('newPassword')" prop="NPwd">
          <el-input type="password" v-model="formData.NPwd" :placeholder="$t('PleaseEnterNewPassword')" />
        </el-form-item>
        <el-form-item :label="$t('confirmPassword')" prop="CNPwd">
          <el-input type="password" v-model="formData.CNPwd" :placeholder="$t('PleaseConfirmPassword')" />
        </el-form-item>
      </el-form>
      <p class="bottom-tip">{{ $t("passwordRequirements") }}</p>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogConfirm" v-loading="loading">{{ $t("confirm") }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { changePassword } from "@api/api";
import util from "@/libs/util";
export default {
  name: "ModifyPwd",
  props: ["type", "token"], //type： 0： 首次登陆 1： 改密码
  data() {
    return {
      accountInfo: {},
      dialogVisible: false,
      formData: {},
      rules: {
        NPwd: { required: true, message: this.$t("PleaseEnterNewPassword"), trigger: "blur" },
        CNPwd: { required: true, message: this.$t("PleaseConfirmPassword"), trigger: "blur" },
      },
      loading: false,
    };
  },
  computed: {
    isFirstLogin() {
      return this.type == 0;
    },
  },
  methods: {
    show(accountInfo = {}) {
      this.accountInfo = accountInfo;
      this.formData = {};
      this.dialogVisible = true;
      this.$nextTick((_) => {
        this.$refs["formData"].clearValidate();
      });
    },
    handleClose() {
      !this.isFirstLogin && (this.dialogVisible = false);
    },
    dialogConfirm() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          const { CNPwd, NPwd } = this.formData;
          const { OPwd } = this.accountInfo;
          //修改密码
          if (CNPwd != NPwd) {
            this.$message.error(this.$t("confirmError"));
            return;
          }
          if (!util.isSafePwd(NPwd)) {
            this.$message.error(this.$t("passwordRequirements"));
            return;
          }
          if (NPwd == OPwd) {
            this.$message.error(this.$t("passwordNoChange"));
            return;
          }
          this.loading = true;
          changePassword({
            _token: this.token,
            data: {
              oldPassword: OPwd,
              newPassword: NPwd,
            },
          })
            .then(() => {
              this.$emit("success");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.el-form-item {
  margin-bottom: 20px;
}
.top-tip {
  text-align: center;
  margin-bottom: 20px;
}
.bottom-tip {
  text-align: left;
  color: #999;
  margin-top: 10px;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/modifyPassword/index.vue"
}
</vue-filename-injector>
